var r=[0,4,8,16,32,64,128,256,512,720,960,1140],a=[0,4,8,16,24,32,40,48,56,80,160,320];export{a as sizes,r as space};
//# sourceMappingURL=sizes.js.map
